<template>
  <div class="home" v-loading="loading">
    <meta name="referrer" content="no-referrer"/>
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <div class="page">
          <!--          <h3>广东省战略性产业人才培养与评价联盟</h3>-->
          <!--          <p style="font-size: 16px">TRAINING AND EVALUATION ALLIANCE FOR KEY INDUSTRIES GUANGDONG</p>-->
        </div>
        <!--        <p class="slogan">立人立己 达人达己</p>-->
      </swiper-slide>
      <!--      <swiper-slide class="swiper-slide slide-two">-->
      <!--        <div class="page">-->
      <!--          <h3>产业集群</h3>-->
      <!--          <p>Suecessful Cass</p>-->
      <!--        </div>-->
      <!--        <ul class="case-item">-->
      <!--          <li-->
      <!--            v-for="(item,index) in caseList"-->
      <!--            :key="index"-->
      <!--            v-lazy:background-image="imgserver + item.Img"-->
      <!--          >-->
      <!--            <router-link-->
      <!--              class="text-decoration"-->
      <!--              :to="{ name: 'casedetails', params: { id: item.Id }}"-->
      <!--            >-->
      <!--              <div class="case-item-hover">-->
      <!--                <p class="hover-title">{{item.Title}}</p>-->
      <!--                <div class="bottom"></div>-->
      <!--                <div class="more">-->
      <!--                  <span>MORE</span>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </router-link>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </swiper-slide>-->
      <swiper-slide class="swiper-slide slide-three">
        <div class="page">
          <h3>最新资讯</h3>
          <p>Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
            <div>
              <router-link :to="{ name: 'newsdetails', params: { id: news.id }}">
                <img style="width: 100%;height: 160px" v-lazy="news.cover" alt/>
              </router-link>
            </div>
            <div class="item-content" >
              <h3>{{ news.title }}</h3>
              <span>{{ news.createTime }}</span>
            </div>
          </div>
          <!--          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">-->
          <!--            <div :style="'order: '+ (i%2==0 ? 1: 3)">-->
          <!--              <router-link-->
          <!--                class="text-decoration"-->
          <!--                :to="{ name: 'newsdetails', params: { id: news.Id }}"-->
          <!--              >-->
          <!--                <div class="item-img" v-lazy:background-image="news.cover"></div>-->
          <!--              </router-link>-->
          <!--            </div>-->
          <!--            <div style="order: 2">-->
          <!--              <el-divider>-->
          <!--                <i class="el-icon-apple"></i>-->
          <!--              </el-divider>-->
          <!--            </div>-->
          <!--            <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">-->
          <!--              <h3>{{news.Title}}</h3>-->
          <!--              <p>{{news.Content}}</p>-->
          <!--              <span>{{news.createTime}}</span>-->
          <!--            </div>-->
<!--        </div>-->
  </div>
  </swiper-slide>
  </swiper>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";

export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [
        {
          "id": "1854045602346704990",
          "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5aFDgCwSA5Uf8X6nk5GLNcna5U4dSGenmQD37dCZ1vCD8ozxTbTIl58CHLDPOIp0Lp31KwP4HE5A/0?wx_fmt=jpeg",
          "title": "李强在上海调研技能人才工作时强调 积极适应经济社会发展需要 大力加强职业教育和技能人才培养",
          "cluName": "动态",
          "src": "战略性产业人才培养与评价",
          "version": 1,
          "releaseStatus": 0,
          "releaseStatusLabel": null,
          "tenantId": "0",
          "tenantName": "技能生态信息平台",
          "chaGroId": null,
          "chaGroName": null,
          "watchCount": null,
          "createBy": "0",
          "createByName": "平台顶级管理员",
          "createTime": "2024年11月04日 15:26",
          "updateBy": "0",
          "updateByName": "平台顶级管理员",
          "updateTime": "2024-11-06 06:18:12",
          "recmStatus": 0,
          "recmSort": null
        },
        {
          "id": "1854045717023174725",
          "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc4AlaBibdRIpLWIPKibgCMic1oxbuZZjmHAMQCzJI5VNHiahRTSAMULOYfjW0dDckDaa55Fn2E1ujQL6w/0?wx_fmt=jpeg",
          "title": "“就业是家事，更是国事”",
          "cluName": "动态",
          "src": "战略性产业人才培养与评价",
          "version": 1,
          "releaseStatus": 0,
          "releaseStatusLabel": null,
          "tenantId": "0",
          "tenantName": "技能生态信息平台",
          "chaGroId": null,
          "chaGroName": null,
          "watchCount": null,
          "createBy": "0",
          "createByName": "平台顶级管理员",
          "createTime": "2024年11月05日 14:48",
          "updateBy": "0",
          "updateByName": "平台顶级管理员",
          "updateTime": "2024-11-06 06:18:40",
          "recmStatus": 0,
          "recmSort": null
        },
        {
          "id": "1854044636914397235",
          "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc7C5Eia2mWw3xWmHYpViaUqtu3tlI2Ydh97ib8kINQDNOOjN1L9oluOz5T3TjsKFKRS9JDlaycj64huQ/0?wx_fmt=jpeg",
          "title": "工信部最新发声涉及5G+工业互联网、人工智能、低空经济……",
          "cluName": "政策文件",
          "src": "战略性产业人才培养与评价",
          "version": 1,
          "releaseStatus": 0,
          "releaseStatusLabel": null,
          "tenantId": "0",
          "tenantName": "技能生态信息平台",
          "chaGroId": null,
          "chaGroName": null,
          "watchCount": null,
          "createBy": "0",
          "createByName": "平台顶级管理员",
          "createTime": "2024年10月25日 15:20",
          "updateBy": "0",
          "updateByName": "平台顶级管理员",
          "updateTime": "2024-11-06 06:14:22",
          "recmStatus": 0,
          "recmSort": null
        },
        {
          "id": "1846012014510481427",
          "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5h8lGvl86ovYDCeS8EX0qeGpiannTibX7cY6OP9Z0aJsaT7923IyicXO1vZKy2Yw0F0Q9lQvgwXRVmQ/0?wx_fmt=jpeg",
          "title": "财政部：五大政策工具已投放20余万亿元，四项增量政策在路上",
          "cluName": "动态",
          "src": "战略性产业人才培养与评价",
          "version": 1,
          "releaseStatus": 0,
          "releaseStatusLabel": null,
          "tenantId": "0",
          "tenantName": "技能生态信息平台",
          "chaGroId": null,
          "chaGroName": null,
          "watchCount": null,
          "createBy": "0",
          "createByName": "平台顶级管理员",
          "createTime": "2024年10月14日 09:39",
          "updateBy": "0",
          "updateByName": "平台顶级管理员",
          "updateTime": "2024-10-15 02:15:36",
          "recmStatus": 0,
          "recmSort": null
        },
        {
          "id": "1846011914925125687",
          "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5sMm4eQaT9bcyO2BBXbOObPgibPOV2zclBdRGmbFic9uL4T1v52AWFts9Cq7OjXsFomjiaPn1o2T8icw/0?wx_fmt=jpeg",
          "title": "澳门青年互联网培训孵化基地“巨量认证（OMC）&互联网营销师-直播销售员“一试双证”首考圆满收官",
          "cluName": "动态",
          "src": "战略性产业人才培养与评价",
          "version": 1,
          "releaseStatus": 0,
          "releaseStatusLabel": null,
          "tenantId": "0",
          "tenantName": "技能生态信息平台",
          "chaGroId": null,
          "chaGroName": null,
          "watchCount": null,
          "createBy": "0",
          "createByName": "平台顶级管理员",
          "createTime": "2024年10月11日 08:03",
          "updateBy": "0",
          "updateByName": "平台顶级管理员",
          "updateTime": "2024-10-15 02:15:12",
          "recmStatus": 0,
          "recmSort": null
        },
        {
          "id": "1846012118034296869",
          "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5DNnqG2mkejksdlClGKNhJya42mJVG1NcDhmAK04thmyJU3fE7le6Rk263tofoG56hv1L9qq6DIg/0?wx_fmt=jpeg",
          "title": "省政府与人力资源社会保障部签署新一轮战略合作协议",
          "cluName": "动态",
          "src": "战略性产业人才培养与评价",
          "version": 1,
          "releaseStatus": 0,
          "releaseStatusLabel": null,
          "tenantId": "0",
          "tenantName": "技能生态信息平台",
          "chaGroId": null,
          "chaGroName": null,
          "watchCount": null,
          "createBy": "0",
          "createByName": "平台顶级管理员",
          "createTime": "2024年10月10日 19:20",
          "updateBy": "0",
          "updateByName": "平台顶级管理员",
          "updateTime": "2024-10-15 02:16:00",
          "recmStatus": 0,
          "recmSort": null
        },
        // {
        //   "id": "1846035929345564733",
        //   "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5r11ABuicFZrgpTmia19RCL6FDW8KGeq9pzr3GgSibPBICiau2kQvxqtBjh1icdBeOeUVo77SibUcbKzKw/0?wx_fmt=jpeg",
        //   "title": "教育部专场解读！国新办发布会聚焦全面推进教育强国建设",
        //   "cluName": "动态",
        //   "src": "战略性产业人才培养与评价",
        //   "version": 1,
        //   "releaseStatus": 0,
        //   "releaseStatusLabel": null,
        //   "tenantId": "0",
        //   "tenantName": "技能生态信息平台",
        //   "chaGroId": null,
        //   "chaGroName": null,
        //   "watchCount": null,
        //   "createBy": "0",
        //   "createByName": "平台顶级管理员",
        //   "createTime": "2024年09月29日 09:58",
        //   "updateBy": "0",
        //   "updateByName": "平台顶级管理员",
        //   "updateTime": "2024-10-15 03:50:37",
        //   "recmStatus": 0,
        //   "recmSort": null
        // },
        // {
        //   "id": "1846012624924319779",
        //   "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5yYucpCCQwb8a3kGxzm1CbTfGLnf1MAoEKBMc6xFdm6DIZcmFbFTUM94XnDA9cjmYibozQFcRXBow/0?wx_fmt=jpeg",
        //   "title": "《中共中央 国务院关于实施就业优先战略促进高质量充分就业的意见》发布",
        //   "cluName": "动态",
        //   "src": "战略性产业人才培养与评价",
        //   "version": 1,
        //   "releaseStatus": 0,
        //   "releaseStatusLabel": null,
        //   "tenantId": "0",
        //   "tenantName": "技能生态信息平台",
        //   "chaGroId": null,
        //   "chaGroName": null,
        //   "watchCount": null,
        //   "createBy": "0",
        //   "createByName": "平台顶级管理员",
        //   "createTime": " 2024年09月26日 09:37",
        //   "updateBy": "0",
        //   "updateByName": "平台顶级管理员",
        //   "updateTime": "2024-10-15 02:18:01",
        //   "recmStatus": 0,
        //   "recmSort": null
        // },
        // {
        //   "id": "1846012341095768097",
        //   "cover": "https://mmbiz.qpic.cn/sz_mmbiz_jpg/4ib9PVXGMlc5sMm4eQaT9bcyO2BBXbOObgmoia5njia9E1l3WNBHYEvos6B1HicZqSedd9ibSYicicbUPO8hcfYZuZzxw/0?wx_fmt=jpeg",
        //   "title": "财政部：下达现代职业教育质量提升计划资金312.57亿元，支持职业教育高质量发展",
        //   "cluName": "动态",
        //   "src": "战略性产业人才培养与评价",
        //   "version": 1,
        //   "releaseStatus": 0,
        //   "releaseStatusLabel": null,
        //   "tenantId": "0",
        //   "tenantName": "技能生态信息平台",
        //   "chaGroId": null,
        //   "chaGroName": null,
        //   "watchCount": null,
        //   "createBy": "0",
        //   "createByName": "平台顶级管理员",
        //   "createTime": "2024年09月24日 09:13",
        //   "updateBy": "0",
        //   "updateByName": "平台顶级管理员",
        //   "updateTime": "2024-10-15 02:16:54",
        //   "recmStatus": 0,
        //   "recmSort": null
        // },


      ],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      }
    };
  },
  created() {
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.loading = false;
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`)
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  }
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;

    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}

//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;

    span {
      color: #fff;
      font-size: 20px;
    }
  }
}

// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home-bg.jpg) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  &-item {
    width: 360px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }

    .el-divider {
      background-color: #fff;
      height: 3px;

      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }

    .item-content {
      width: 340px;
      padding: 10px;
      background: #fff;
      margin-bottom: 40px;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }

      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }

      h3,
      p,
      span {
        color: #000;
      }
    }
  }
}

.order {
  order: -1;
}

.order-img {
  order: 1;
}
</style>
